var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBessSolarCharged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83332 6.79161V19.0416M12.9167 12.9166H4.74998M21.0833 7.81245L18.0208 12.9166H22.1042L19.0417 18.0208M4.74998 7.07745V18.7558C4.74999 18.911 4.78537 19.0641 4.85343 19.2035C4.9215 19.343 5.02046 19.4651 5.14279 19.5605C5.26512 19.656 5.40761 19.7223 5.55941 19.7545C5.71122 19.7866 5.86836 19.7837 6.01888 19.746L12.1439 18.2147C12.3646 18.1594 12.5606 18.032 12.7006 17.8526C12.8406 17.6731 12.9166 17.4521 12.9167 17.2245V8.6087C12.9166 8.38112 12.8406 8.16008 12.7006 7.98067C12.5606 7.80127 12.3646 7.67379 12.1439 7.61849L6.01888 6.08724C5.86836 6.04953 5.71122 6.04664 5.55941 6.07877C5.40761 6.11091 5.26512 6.17722 5.14279 6.27269C5.02046 6.36815 4.9215 6.49025 4.85343 6.6297C4.78537 6.76915 4.74999 6.92227 4.74998 7.07745Z",
    stroke: "#2B8D3F",
    strokeWidth: 2.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBessSolarCharged);
export default __webpack_public_path__ + "static/media/bess_solar_charged.b83f7ed8819882dcc3b55fb366de6bdc.svg";
export { ForwardRef as ReactComponent };